import React, { useEffect, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Link, useLocation, useRouteMatch } from 'react-router-dom';
import { Grid, IconButton, LinearProgress, Tooltip } from '@mui/material';
import ReadMoreIcon from '@mui/icons-material/ReadMore';

import { getDataList } from '../../../../helpers/getDataList';
import PageHeader from '../../includes/PageHeader';
import showMessage from '../../../../helpers/showMessage';
import { useSnackbar } from 'notistack';
import { Box } from '@mui/system';

export function ChannelTypeList() {
    const { pathname } = useLocation();

    const columns = [
        // {
        //     field: 'id',
        //     headerName: 'ID',
        //     // width: 90
        //     flex: 1,
        // },
        {
            field: 'name',
            headerName: 'Нэр',
            // width: 250,
            flex: 1,
        },
        {
            field: 'description',
            headerName: 'Тайлбар',
            // width: 500,
            flex: 1,
        },
        {
            field: 'active',
            headerName: 'Төлөв',
            // width: 90
            flex: 1,
            valueFormatter: ({ value }) => value ? 'идэвхтэй' : 'идэвхгүй',
        },
        {
            field: 'edit',
            headerName: 'Дэлгэрэнгүй',
            renderCell: (params) => {
                return (
                    <div>
                        <Link to={`${pathname}/${params.id}`}>
                            <Tooltip title="Засах">
                                <IconButton>
                                    <ReadMoreIcon />
                                </IconButton>
                            </Tooltip>
                        </Link>
                    </div>
                );
            },
            // width: 115,
            flex: 1,
        },
    ];

    const [isLoading, setIsLoading] = useState(true);
    const [channelList, setChannelList] = useState([]);
    const { enqueueSnackbar } = useSnackbar();
    const [pageSize, setPageSize] = useState(100);
const localizedTextsMap = {
  columnMenuUnsort: "Ангилаагүй",
  columnMenuSortAsc: "Өсөхөөр эрэмблэх",
  columnMenuSortDesc: "Буурахаар эрэмблэх",
  columnMenuFilter: "Хайх",
  columnMenuHideColumn: "Нуух",
  columnMenuShowColumns: "Багана харах"
};
    useEffect(() => {
        let isActive = true;

        getDataList('channel/channel-types/all')
            .then((response) => {
                if (isActive) {
                    setChannelList(response.data?.data);
                }
                setIsLoading(false);
            })
            .catch((error) => {
                const message = error.response?.data?.message
                    ? error.response.data.message
                    : error.message;
                showMessage(message, enqueueSnackbar, 'error');
            });

        return () => {
            isActive = false;
        };
    }, []);

    const { path } = useRouteMatch();

    return (
        <Grid
            container
            justifyContent="center"
            style={{ height: 630, width: '100%' }}
        >
            <PageHeader pageName="Суваг төрөл" addNewLink={path + '/create'} />
            {isLoading ? (
                <Box sx={{ width: '100%' }}>
                    <LinearProgress />
                </Box>
            ) : (
                <DataGrid
                    rows={channelList}
                    columns={columns}
                    pageSize={pageSize}
                    onPageSizeChange={(newPage) => setPageSize(newPage)}
                    rowsPerPageOptions={[10, 20, 30, 40, 50]}
                    pagination
                    checkboxSelection={false}
                        disableSelectionOnClick
                        localeText={localizedTextsMap}
                />
            )}
        </Grid>
    );
}
